var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94794 1.20943C7.7721 0.832328 7.39103 0.616416 6.99973 0.632661C6.60862 0.616631 6.22782 0.832519 6.05205 1.20945L0.135396 13.8978C-0.0980095 14.3983 0.118546 14.9933 0.619086 15.2267C1.11963 15.4601 1.71461 15.2435 1.94801 14.743L3.39869 11.632H10.6013L12.052 14.743C12.2854 15.2435 12.8804 15.4601 13.3809 15.2267C13.8814 14.9933 14.098 14.3983 13.8646 13.8977L7.94794 1.20943ZM9.6687 9.632L7 3.90897L4.33131 9.632H9.6687Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.3682C0.447715 17.3682 0 17.8159 0 18.3682C0 18.9205 0.447715 19.3682 1 19.3682H13C13.5523 19.3682 14 18.9205 14 18.3682C14 17.8159 13.5523 17.3682 13 17.3682H1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColorIcon);
export default __webpack_public_path__ + "static/media/text-color-icon.0414d79c1fa9b040a3de33b8c4cdbbf6.svg";
export { ForwardRef as ReactComponent };